export default __webpack_public_path__ + "media/images/archetypes/booster-ec858810fb2ffd715404c0e2c5071f35.png";